export default __webpack_public_path__ + "static/media/business_show_6.274fa8a5.png";